import { Modal as AntModal } from "antd";
import classNames from "classnames";
import styles from "./modal.module.scss";

export const Modal = ({ children, footer, className, ...props }) => (
  <AntModal
    centered
    className={classNames("s2-theme-style", className, {
      "no-footer": footer === null,
    })}
    footer={footer}
    okText="Save"
    {...props}
  >
    <div className={`scrollable-container ${styles.modalContent}`}>
      {children}
    </div>
  </AntModal>
);
